<template>
    <div :class="['insert-rec','insert-shop-card','shop-telephone',expiredClass]">  
    <a href="javascript:void(0);" class="insert-box" data-spm-data="t" :data-spm-content="dataSpmContent">
        <div class="img-box img-do">
            <img class="insert-article__img" :src="image" alt="配图">
        </div>
        <div class="insert-content">
            <h5 class="insert-rec__title">{{title}}</h5>
            <div class="footer">
                <p v-if="p1">{{p1}}</p>
                <p v-if="p2">{{p2}}</p>
                <p class="price-number" v-if="price">{{price}}</p>
            </div>
        </div>

        <div class="insert-btn telphone">
            <i class="telephone-icon"></i>
            {{phoneNum}}
            <span v-if="extPhoneNum">转{{extPhoneNum}}</span>
        </div>
    <div style="clear: both;"></div>
    </a>
    <div class="rec" v-if="cardInfo.accountName && cardInfo.avatar">
        <div class="rec-avator"><img :src="cardInfo.avatar"/></div>
        <div class="rec-text">{{cardInfo.accountName}}推荐</div>
        <div class="rec-expired-tag" v-if="status === 4 || status === 3">已失效</div>
    </div>
</div>
</template>

<script>
import { setPicSize } from "../../../utils/pic-util.js"

export default {
	name: "external-poster",
    props: {
        cardInfo: {
			type: Object,
			default: () => {
				return {};
			},
		},
    },
    data() {
        return {

        }
    },
    mounted() {
    },
    computed: {
        fields() {
            return this.cardInfo?.fields || {}
        },
        title() {
            return this.fields?.title?.substring(0,26) || ''
        },
        desc() {
            return this.fields?.desc?.substring(0,26) || ''
        },
        image() {
            return setPicSize(this.fields?.image, 1060, undefined, 'c_zoom')
        },
        dataSpmContent() {
            return '||' + this.cardInfo?.uuid + '|||'
        },
        status() {
            return this.cardInfo?.status || 1
        },
        expiredClass() {
            return this.status === 4 || this.status === 3 ? 'expired' : ''
        },
        phoneNum() {
            let phoneNum = this.fields?.phoneNum
            // 手机号码的不同展示方式
            if (phoneNum.length === 12) {
                phoneNum = phoneNum.slice(0,4) + '-' + phoneNum.slice(4,8) + '-' + phoneNum.slice(8, phoneNum.length);
            } else if (phoneNum.length === 11) {
                phoneNum = phoneNum.slice(0,3) + '-' + phoneNum.slice(3,7) + '-' + phoneNum.slice(7, phoneNum.length);
            } else {
                phoneNum = phoneNum.slice(0,3) + '-' + phoneNum.slice(3,6) + '-' + phoneNum.slice(6, phoneNum.length);
            }
            return phoneNum
        },
        extPhoneNum() {
            return this.fields?.extPhoneNum
        },
        price() {
            return this.fields?.price
        },
        p2() {
            return this.fields?.area
        },
        p1() {
            let p1 = this.fields?.address || this.fields?.desc
            if(this.p2) {
                return p1?.substring(0,22)
            }
            return p1?.substring(0,50)
        },
        
    },
}
</script>

<style lang="less" scoped>

</style>